<!--Matter Document Upload Component HTML -->
<div class="col-sm-12 compswitch">
  <div class="row">
    <div class="col-6">
      <h5 class="float-left grpFont docupdate matname">Matter Name - {{truncateString(data.Title)}}</h5>
    </div>
    <div class="col-6"></div>

    <!-- <div class="col-sm-3 col-xs-1"></div>
    <div class="col-sm-2 col-xs-3 round-icon">
      <!-- <div>
        <p class="selectprior optionhigh2 casetito" [matTooltip]="data.Title" matTooltipPosition="after">
          {{truncateString(data.Title)}}
        </p>
      </div> --
      <!-- <p class="selectprior optionhigh2 casetito" [matTooltip]="data.Title" matTooltipPosition="after"> {{truncateString(data.Title)}} </p>
       <div class="flex-container">
         <b class="selGroup" *ngIf="product !== 'corporate'">Selected Client(s):</b>
         <b class="selGroup" *ngIf="product === 'corporate'">Selected External Counsel(s):</b>
         <div class="divShow" *ngFor="let item of (showAllItems ? groupName : groupName.slice(0, 2)); let i = index">
           {{ item }}
           <span *ngIf="groupName.length == 1"> </span>
           <span *ngIf="groupName.length > 1 && i < (showAllItems ? groupName.length : 2) - 1">, </span>
         </div>
         <div *ngIf="groupName.length > 2" class="view-more-less" (click)="toggleView()">
           <a href="javascript:void(0)" style="font-size: 14px;">{{ showAllItems ? 'View Less' : 'View More' }}</a>
         </div>
       </div> --
    </div> -->
  </div>

  <div class="col-12 Individual createGroup hole">
    <div class="row">
      <!-- <h5 class="float-left grpFont docupdate">Matter Name - {{truncateString(data.Title)}}</h5>  -->
      <!-- Main Upload Section -->
      <div class="col-12 matterpadding">
        <h5 class="float-left grpFont">Attach Document(s)</h5>

        <!-- Upload New Document Section -->
        <div *ngIf="currentTab=='uploadnew'" class="upload-container">
          
          <!-- File Upload Dropzone -->
          <div class="upload-section-matter">
            <div class="form-group">
              <label for="file-upload" class="form-label">
                <!-- <span *ngIf="uploadedDocs.length == 0">
                  Select Document(s) <span class="mandate">*</span>
                </span> -->
                <!-- <span *ngIf="uploadedDocs.length > 0">
                  Selected Document(s) to upload <span class="mandate">*</span>
                </span> -->
              </label>

              <div class="upload-dropzone"
                   (dragover)="onDragOver($event)"
                   (dragleave)="onDragLeave($event)"
                   (drop)="onDrop($event)"
                   [class.drag-over]="isDragOver">

                <input #fileInput type="file" multiple hidden (change)="handleFileInput($event)" />

                <div class="dropzone-content" (click)="fileInput.click()">
                  <!-- <div class="upload-icon-wrapper">
                    <i class="fa fa-upload upload-icon"></i>
                  </div>
                  <div class="dropzone-text-wrapper">
                    <p class="dropzone-text">
                      Drag and drop or <span class="browse-link">browse</span>
                    </p>
                    <p class="file-types">PDF, DOC, DOCX, JPG, PNG</p>
                  </div> -->
                  <div class="dropzone-text-wrapper">
                    <div class="upload-icon"><i class="fas fa-cloud-upload-alt"></i></div>
                    <p class="dropzone-text">
                      Choose the files you want to upload from your device or
                      <br>
                      drag & drop them here
                    </p>
                    <button type="button" class="browse-btn">Browse Files</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Selected Documents Section -->
          <div class="selected-documents-section" *ngIf="uploadedDocs.length > 0">
            <h2 class="section-title">
              Selected Document(s)
              <span class="document-count">({{uploadedDocs.length}})</span>
            </h2>

            <!-- Document Cards Container -->
            <div class="document-cards-container">
              <div class="document-card" *ngFor="let item of uploadedDocs; let i = index"
                   [ngClass]="{'expanded': selectedIdx === i}">

                <!-- Document Header (Always Visible) -->
                <div class="document-header">
                  <div class="doc-info">
                    <i class="fa fa-file-text doc-icon"></i>
                    <div class="doc-details">
                      <div class="doc-name">{{item.name}}</div>
                      <div class="doc-size">
                        <!-- {{(item.size?.size / 1024).toFixed(2)}} KB -->
                        {{ (item.size / 1024) | number:'1.2-2' }} KB
                      </div>
                    </div>
                  </div>
                  <div class="doc-actions">
                    <i class="fas fa-edit action-icon edit-icon" (click)="editDocument(item, i)"
                       matTooltip="Edit metadata"></i>
                    <i class="fa fa-trash action-icon trash-icon" (click)="removeNewDocument(item, i)"
                       matTooltip="Remove document"></i>
                  </div>
                </div>

                <!-- Document Metadata Form (Collapsible) -->
                <div class="document-metadata" *ngIf="selectedIdx === i && editDoc">
                  <hr class="divider">

                  <form [formGroup]="documentDetail" (ngSubmit)="onSubmit()">
                    <div class="row metadata-row">

                      <!-- Left Column -->
                      <div class="col-6">
                        <div class="form-group">
                          <label for="documentName" class="form-label">
                            Document Name <span class="mandate">*</span>
                          </label>
                          <input type="text"
                                 class="form-control textbox"
                                 id="documentName"
                                 name="documentName"
                                 formControlName="name"
                                 [maxLength]="50"
                                 (input)="restricttextSpace($event)"
                                 oninput="this.value = this.value.replace(/[^A-Za-z0-9-()._ ]|^ /g,'')"
                                 [ngClass]="{'is-invalid': submitted && f.name.errors}"
                                 autocomplete="off">

                          <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
                            <div *ngIf="f.name.errors.required">Document Name is required</div>
                          </div>

                          <div class="char-counter" *ngIf="f.name.value">
                            {{f.name.value.length}}/50
                          </div>
                        </div>

                        <div class="form-group">
                          <label for="description" class="form-label">
                            Description
                          </label>
                          <textarea rows="4"
                                    class="form-control textbox"
                                    formControlName="description"
                                    name="description"
                                    (input)="restricttextSpace($event)"
                                    oninput="this.value = this.value.replace(/[^A-Za-z0-9-()._ ]|^ /g,'')"
                                    maxlength="300"
                                    placeholder="Add description"></textarea>

                          <div class="char-counter" *ngIf="f.description.value">
                            {{f.description.value.length}}/300
                          </div>
                        </div>
                      </div>

                      <!-- Right Column -->
                      <div class="col-6">
                      
                        <div class="form-group expiration-field">
                          <label for="expiration-date" class="form-label">
                            Expiration Date <span class="optional-label">(Optional)</span>
                          </label>
                        
                          <div class="custom-date-wrapper">
                            <!-- <input #expiryDp="bsDatepicker" bsDatepicker [bsConfig]="expirationDatePickerConfig"
                              formControlName="date_of_filling" class="form-control textbox date-input custom-input" 
                              placeholder="Choose a date" readonly (click)="expiryDp.show()" /> -->
                        
                              <input #expiryDp="bsDatepicker" bsDatepicker [bsConfig]="expirationDatePickerConfig" formControlName="date_of_filling"
                                class="form-control textbox date-input custom-input" placeholder="Choose a date" readonly />

                            <button class="icon-btn date-toggle" type="button" (click)="expiryDp.toggle(); $event.stopPropagation()">
                              <i class="fa-regular fa-calendar calendar-icon"></i>
                            </button>
                          </div>
                        </div>

                        <div class="toggle-row">
                          <div class="toggle-box">
                            <span class="toggle-label">Encryption</span>
                            <span class="toggle-switch"
                                  [class.active]="item.custom_encrypt"
                                  (click)="encrypttoggle(item, item.custom_encrypt)">
                            </span>
                          </div>

                          <div class="toggle-box">
                            <span class="toggle-label">Download</span>
                            <span class="toggle-switch"
                                  [class.active]="item.downloadDisabled"
                                  (click)="disableDoc(item, item.downloadDisabled)">
                            </span>
                          </div>
                        </div>

                        <!-- Tags Section -->
                        <div class="tags-section">
                          <label class="form-label">
                            Tags <span class="optional-label">(Optional)</span>
                          </label>

                          <div class="tags-container" *ngIf="showTagInputs">
                            <div class="tag-row" *ngFor="let value of currentDocTags; let i = index">
                              
                              <!-- TAG TYPE -->
                              <div class="tag-input-block">
                                <input type="text"
                                       class="tag-input"
                                       placeholder="Tag type"
                                       [(ngModel)]="value.tagtype"
                                       (ngModelChange)="checkDuplicateTagType(i)"
                                       [ngModelOptions]="{ standalone: true }"
                                       maxlength="30" />
                                <div class="char-counter" *ngIf="value.tagtype">
                                  {{ value.tagtype.length }}/30
                                </div>
                              </div>

                              <!-- TAG VALUE -->
                              <div class="tag-input-block">
                                <input type="text"
                                       class="tag-input tag-value-input"
                                       placeholder="Tags"
                                       [(ngModel)]="value.tag"
                                       [ngModelOptions]="{ standalone: true }"
                                       maxlength="100" />
                                <div class="char-counter" *ngIf="value.tag">
                                  {{ value.tag.length }}/100
                                </div>
                              </div>

                              <!-- REMOVE -->
                              <i class="fa-solid fa-xmark remove-tag" (click)="removeTagRow(i)"></i>
                            </div>
                          </div>

                          <button type="button" class="add-tag-btn" (click)="addTagRow()">
                            <i class="fa fa-plus"></i> Add Tags
                          </button>
                        </div>

                      </div>

                    </div>

                    <!-- Action Buttons -->
                    <div class="form-actions">
                      <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
                      <button type="submit" class="btn btn-primary">Save</button>
                    </div>

                  </form>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- Main Action Buttons -->
    <div class="btnbox" *ngIf="!editDoc && !addTag">
      <button type="reset" class="btn btn-default btncancel btnrightitem btnc" (click)="OnCancel()">Cancel</button>
      <button type="reset" class="btn btn-default btncancel btnrightitem btnc" *ngIf="uploadedDocs?.length > 0" (click)="OnSaveLater()">Save for Later</button>
      <!-- <button type="submit" class="btn btn-primary btnsave savecls btns" *ngIf="uploadedDocs?.length > 0" (click)="saveDocuments()">Upload</button>
      <button type="submit" class="btn btn-primary btnsave savecls btns" *ngIf="uploadedDocs?.length == 0" (click)="saveDocuments()">Save</button> -->
         
      <button type="submit" class="btn btn-primary btnsave savecls btns" (click)="saveDocuments()">Save</button>
    </div>

  </div>
</div>

 <ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>